import { Component, NgZone, OnInit } from "@angular/core";
import {
  IClientAuthorizeCallbackData,
  ICreateOrderRequest,
  IPayPalConfig,
} from "ngx-paypal";
import { environment } from "@env/environment";
import { Router, ActivatedRoute } from "@angular/router";
import { LoaderService } from "../../../core/services/loader/loader.service";
import { ProductService } from "../../services/product/product.service";
import { NotificationService } from "../../../core/services/notification/notification.service";
import { CryptoKeyValue, PaymentType } from "../../constants";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EncrDecrService } from "../../services/encr-decr-service.service";
import { FilterModel } from "@app/shared/models/filter-model";
import * as braintree from "braintree-web";
import { AddressModel } from "@app/feature/super-admin/models/client";
import { AddressService } from "@app/shared/services/address/address.service";
import { BraintreeService } from "@app/shared/services/braintree/braintree.service";

export interface ManualPayment {
  PaymentId: string;
  PayerId: string;
  DesignId: string;
  PaymentMethod?: number;
  PaymentNonce?: string;
  Address?: AddressModel;
}
@Component({
  selector: "app-embroidery-product-info",
  templateUrl: "./embroidery-product-info.component.html",
  styleUrls: ["./embroidery-product-info.component.scss"],
})
export class EmbroideryProductInfoComponent implements OnInit {
  infoList: any[];
  pageSize = 10;
  isDisplay = "none";
  isFullListDisplayed: boolean = false;
  filter: FilterModel;
  parentRouteParam!: any;
  infoCount: any;
  userRole: any;
  manualPayment!: ManualPayment;
  public payPalConfig?: IPayPalConfig; // for paypal configuration
  DesignId: any;
  flag: boolean = false;
  charge: number;
  ProductName: any;
  searchEmbroideryProductForm: FormGroup;
  scrolling: boolean;
  totalRecordsCount: number;
  pageIndex: number;
  imgBaseURL = environment.imgBaseURL;
  hostedFieldsInstance: braintree.HostedFields;
  isCreditCardFormLoad: boolean;
  braintreeClientToken: string;
  countries!: any[];
  states!: any[];
  Role = localStorage.getItem("role");
  isSuperAdmin = "";

  constructor(
    private loader: LoaderService,
    private productservice: ProductService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private zone: NgZone,
    private addressService: AddressService,
    private brainTreeService: BraintreeService
  ) {
    this.searchEmbroideryProductForm = this.formBuilder.group({
      searchProduct: [""],
    });
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe((params) => {
        this.parentRouteParam = params["storename"];
      });
    }
  }
  ngOnInit() {
    this.getCountries();
    this.getStatesByCountry(1);

    this.userRole = localStorage.getItem("role");
    this.intiliaze();

    this.fn_getEmbroideryProductDetailList();
    if (this.Role == "SuperAdmin") {
      this.isSuperAdmin = "true";
    } else {
      this.isSuperAdmin = "false";
    }
  }
  intiliaze() {
    this.fn_ResetProductList();
    this.filter = {
      searchBy: "",
      Skip: 0,
      Take: this.pageSize,
      UserId: Number(localStorage.getItem("userId")),
    };
    this.manualPayment = {
      PayerId: "",
      PaymentId: "",
      DesignId: "",
      PaymentMethod: null,
      PaymentNonce: null,
      Address: {
        AddressLine: null,
        City: null,
        State: null,
        CountryCode: null,
        ZipCode: null,
        Country: null,
        LandMark: null,
        PhoneNumber: null,
        StateCode: null,
      },
    };
  }
  fn_getEmbroideryProductDetailList() {
    this.loader.show();
    this.filter.Skip = this.infoCount;
    this.productservice
      .fn_getEmbroideryProductDetailList(this.filter)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.fn_AddLazyLoadedItems(res.Data.ResponseData);
            this.loader.lazyLoaderHide();
          } else if (res.StatusCode === 204) {
            this.loader.hide();
          } else {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          this.loader.lazyLoaderHide();
        }
      );
  }
  fn_AddLazyLoadedItems(items: any) {
    this.loader.show();
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.infoList.find((x) => x.DesignId == items[i].DesignId)) {
          this.infoCount = this.infoList.push(items[i]);
        }
      }

      this.isDisplay = this.infoCount > 0 ? "none" : "block";
    }
    if (items.length < this.pageSize) {
      this.isFullListDisplayed = true;
    }
    this.loader.hide();
  }

  fn_PaypalInitConfig(): void {
    this.payPalConfig = {
      currency: "USD",
      clientId: environment.paypalPublicKey,
      createOrderOnClient: (data): ICreateOrderRequest => {
        return {
          intent: "CAPTURE",
          purchase_units: [
            {
              amount: {
                currency_code: "USD",
                value: this.charge.toString(),
                breakdown: {
                  item_total: {
                    currency_code: "USD",
                    value: this.charge.toString(),
                  },
                },
              },
              items: [
                {
                  name: "D-" + this.DesignId.toString(),
                  quantity: "1",
                  category: "DIGITAL_GOODS",
                  unit_amount: {
                    currency_code: "USD",
                    value: this.charge.toString(),
                  },
                },
              ],
            },
          ],
        };
      },
      advanced: {
        commit: "true",
      },
      style: {
        label: "pay",
        layout: "horizontal",
      },
      onApprove: (data, actions) => {},
      onClientAuthorization: (data: IClientAuthorizeCallbackData) => {
        this.fn_PaymentSuccess(data);
      },
      onCancel: (data, actions) => {
        window.location.reload();
        this.notificationService.info(
          "Your transaction has been cancelled",
          "Payment"
        );
      },
      onError: (err) => {
        this.router.navigate([this.parentRouteParam + "/paymentfailed"]);
        window.location.reload();
      },
      onClick: (data, actions) => {},
    };
  }
  fn_PaymentSuccess(data: IClientAuthorizeCallbackData) {
    this.zone.run(() => {
      this.manualPayment.PaymentMethod = PaymentType.Paypal;
      this.manualPayment.PaymentId = data.id;
      this.manualPayment.PayerId = data.payer.payer_id;
      this.manualPayment.DesignId = this.DesignId;
      // removing null values
      Object.keys(this.manualPayment.Address).forEach(
        (key) =>
          this.manualPayment.Address[key] == null &&
          delete this.manualPayment.Address[key]
      );
      Object.keys(this.manualPayment).forEach(
        (key) =>
          this.manualPayment[key] == null && delete this.manualPayment[key]
      );
      this.loader.show();
      this.productservice
        .fn_SetManualPaymentForEmbroideryProduct(this.manualPayment)
        .subscribe(
          (res: any) => {
            this.loader.show();
            if (res.StatusCode === 200) {
              this.notificationService.success(res.Message, "Success");
              this.infoCount = 0;
              this.infoList = [];
              this.flag = false;
              this.fn_getEmbroideryProductDetailList();
              this.loader.hide();
            } else {
              this.notificationService.error(res.Message, "error");
              this.loader.hide();
            }
          },
          (err: any) => {
            this.loader.hide();
          }
        );
    });
  }
  fn_Pay(id: any, charge: number, name: any, image: any) {
    if (charge > 0) {
      this.DesignId = id;
      this.charge = charge;
      this.ProductName = name;
      this.flag = true;
      this.brainTreeService.GetPaymentToken().subscribe(
        (res) => {
          if (res.StatusCode === 200) {
            this.braintreeClientToken = res.Data.ResponseData;
            this.createBraintreeUI();
          }
        },
        (error: any) => {
          console.log(error);
          this.notificationService.error(
            "Payment gateway loading error",
            "Payment"
          );
        }
      );
      this.fn_PaypalInitConfig();
    }
  }

  fn_close() {
    this.flag = !this.flag;
  }

  fn_searchProduct(form: FormGroup) {
    this.isDisplay = "none";
    this.fn_ResetProductList();
    let searchString = form.controls["searchProduct"].value;
    this.filter.Skip = 0;
    this.filter.searchBy =
      this.fn_CheckForNullUndefinedEmptyString(searchString);
    this.fn_getEmbroideryProductDetailList();
  }

  /** Resets product list */
  fn_ResetProductList() {
    this.infoList = [];
    this.isFullListDisplayed = false;
    this.scrolling = false;
    this.infoCount = 0;
    this.totalRecordsCount = 0;
    this.pageIndex = 0;
  }

  fn_CheckForNullUndefinedEmptyString(value: any) {
    if (value === null || value === "" || value === undefined) {
      return "";
    } else {
      return value;
    }
  }

  /**Redireect user to view store screen */
  fn_ViewProduct(productId: any, designId: any, type: number) {
    var encryptedproductId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      String(productId)
    );
    var encrypteddesignId = this.EncrDecr.set(
      CryptoKeyValue.Key,
      String(designId)
    );
    if (
      this.userRole == "StoreAdmin" ||
      this.userRole === "StoreOwner" ||
      this.userRole === "StoreStaffMember"
    )
      this.router.navigate(["/store/product/details"], {
        queryParams: {
          pid: encryptedproductId,
          designId: encrypteddesignId,
          type: type,
          IsSuperAdmin: this.isSuperAdmin,
        },
      });
    else
      this.router.navigate([this.parentRouteParam + "/product/details"], {
        queryParams: {
          pid: encryptedproductId,
          designId: encrypteddesignId,
          type: type,
          IsSuperAdmin: this.isSuperAdmin,
        },
      });
  }

  createBraintreeUI() {
    braintree.client
      .create({
        authorization: this.braintreeClientToken,
      })
      .then((clientInstance) => {
        braintree.hostedFields
          .create({
            client: clientInstance,
            styles: {
              // Override styles for the hosted fields
              input: {
                color: "#282c37",
                transition: "color 0.1s",
              },
              // Style the text of an invalid input
              "input.invalid": {
                color: "#E53A40",
              },
              // placeholder styles need to be individually adjusted
              "::-webkit-input-placeholder": {
                color: "rgba(0,0,0,0.6)",
              },
              ":-moz-placeholder": {
                color: "rgba(0,0,0,0.6)",
              },
              "::-moz-placeholder": {
                color: "rgba(0,0,0,0.6)",
              },
              ":-ms-input-placeholder": {
                color: "rgba(0,0,0,0.6)",
              },
              // prevent IE 11 and Edge from
              // displaying the clear button
              // over the card brand icon
              "input::-ms-clear": {
                opacity: "0",
              },
            },
            // The hosted fields that we will be using
            // NOTE : cardholder's name field is not available in the field options
            // and a separate input field has to be used incase you need it
            fields: {
              cardholderName: {
                selector: "#cc-name",
                placeholder: "Name as it appears on your card",
              },
              number: {
                selector: "#card-number",
                placeholder: "1111 1111 1111 1111",
              },
              cvv: {
                selector: "#cvv",
                placeholder: "123",
              },
              expirationDate: {
                selector: "#expiration-date",
                placeholder: "MM/YY",
              },
              postalCode: {
                selector: "#cc-postal-code",
                placeholder: "11111",
              },
            },
          })
          .then((hostedFieldsInstance) => {
            this.hostedFieldsInstance = hostedFieldsInstance;
            // this.isCreditCardFormLoad = true;

            hostedFieldsInstance.on("validityChange", (event) => {
              // Check if all fields are valid, then show submit button
              var formValid = Object.keys(event.fields).every(function (key) {
                return event.fields[key].isValid;
              });

              this.zone.run(() => {
                if (formValid) {
                  this.isCreditCardFormLoad = true;
                } else {
                  this.isCreditCardFormLoad = false;
                }
              });
            });

            hostedFieldsInstance.on("empty", function (event) {
              document.querySelector("#card-image").setAttribute("class", "");
              document.querySelector("#card-image").setAttribute("title", "");
            });

            hostedFieldsInstance.on("cardTypeChange", function (event) {
              // Change card bg depending on card type
              if (event.cards.length === 1) {
                document.querySelector("#card-image").setAttribute("class", "");
                document
                  .querySelector("#card-image")
                  .classList.add(event.cards[0].type);
                document
                  .querySelector("#card-image")
                  .setAttribute("title", event.cards[0].niceType);

                // Change the CVV length for AmericanExpress cards
                if (event.cards[0].code.size === 4) {
                  hostedFieldsInstance.setAttribute({
                    field: "cvv",
                    attribute: "placeholder",
                    value: "1234",
                  });
                }
              } else {
                hostedFieldsInstance.setAttribute({
                  field: "cvv",
                  attribute: "placeholder",
                  value: "123",
                });
              }
            });
          });
      });
  }
  tokenizeUserDetails() {
    let state = this.hostedFieldsInstance._state;
    Object.keys(state.fields).forEach(function (field) {
      if (!state.fields[field].isValid) {
        this.toast.error(
          "Card fields are invalid. Please check again.",
          "Error"
        );
        return false;
      }
    });

    this.loader.show();
    this.hostedFieldsInstance
      .tokenize()
      .then((payload) => {
        // submit payload.nonce to the server from here
        this.fn_PaymentSuccessonCard(payload);
      })
      .catch((error) => {
        this.notificationService.error(
          error.message +
            "," +
            "invalid field " +
            error.details.invalidFieldKeys[0],
          "Error"
        );
        console.log(error);
        this.loader.hide();
        // perform custom validation here or log errors
      });
  }
  fn_PaymentSuccessonCard(payload) {
    this.manualPayment.PaymentMethod = PaymentType.CreditCard;
    this.manualPayment.PaymentNonce = payload.nonce;
    this.manualPayment.DesignId = this.DesignId;
    // removing null values
    Object.keys(this.manualPayment.Address).forEach(
      (key) =>
        this.manualPayment.Address[key] == null &&
        delete this.manualPayment.Address[key]
    );
    Object.keys(this.manualPayment).forEach(
      (key) => this.manualPayment[key] == null && delete this.manualPayment[key]
    );
    this.loader.show();
    this.productservice
      .fn_SetManualPaymentForEmbroideryProduct(this.manualPayment)
      .subscribe(
        (res: any) => {
          this.loader.show();
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, "Success");
            this.infoCount = 0;
            this.infoList = [];
            this.flag = false;
            this.fn_getEmbroideryProductDetailList();
            this.loader.hide();
          } else {
            this.notificationService.error(res.Message, "error");
            this.loader.hide();
          }
        },
        (err: any) => {
          this.notificationService.error("", "Request error");
          this.loader.hide();
        }
      );
  }

  /** Get all countries */
  getCountries() {
    this.addressService.getCountries().subscribe(
      (res: any) => {
        this.countries = res.Data.ResponseData.filter((x) => x.Value == 1);
        this.manualPayment.Address.Country = res.Data.ResponseData.filter(
          (x) => x.Value == 1
        )[0].Text;
      },
      (err) => {}
    );
  }

  /** Get states by counktry */
  getStatesByCountry(event: any) {
    if (event !== null && event !== 0) {
      this.loader.show();
      this.addressService.getStatesByCountry(event).subscribe(
        (res: any) => {
          this.states = res.Data.ResponseData;
          this.loader.hide();
        },
        (err) => {
          this.loader.hide();
        }
      );
    }
  }
}
